import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { of } from 'rxjs';
import { delay, map } from 'rxjs/operators';

import { CameraTestModalComponent } from 'src/app/events/live/camera-test/camera-test-modal.component';
import { DefaultReconnectPolicy } from 'src/app/_helpers/signalR-retry-policy';
import { ConferenceRoomViewModel, GetStreamboxStateViewModel, StreamBoxStateViewModel } from 'src/app/_models/generatedModels';
import { EventRole, SelectedDevice } from 'src/app/_models/models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AdminConferenceSettingsService, OrganizationService, StreamBoxService } from 'src/app/_services/generatedServices';
import { OpentokService } from 'src/app/_services/opentok.service';

declare var zE: any;
const initLayoutContainer = require('opentok-layout-js');

@Component({
  selector: 'bxl-streambox-multiview.component',
  templateUrl: 'streambox-multiview.component.html',
})
export class StreamboxMultiView implements OnInit {
  initialized = false;
  public selectedDevice: SelectedDevice;
  publisher: OT.Publisher;
  layout: any;
  @ViewChild('webRTCLayoutContainer') webRTCLayoutContainer: ElementRef;
  openTokInitialized: boolean;
  publishing: boolean;
  selectedBoxes: number[];
  rooms: ConferenceRoomViewModel[];
  streamBoxId: number;
  connection: any;
  streamboxes: StreamBoxStateViewModel[];
  selectedBox: StreamBoxStateViewModel;

  constructor(private modalService: NgbModal, private streamboxService: StreamBoxService, private route: ActivatedRoute, private auth: AuthenticationService, private admin: OrganizationService, private renderer: Renderer2, private ref: ChangeDetectorRef, private opentokService: OpentokService) {}

  ngOnInit(): void {
    document.body.style.backgroundColor = '#333';
    zE('webWidget', 'hide');

    this.route.paramMap.subscribe((params) => {
      this.route.queryParamMap.subscribe((queryParam) => {
        let query = queryParam.get('ids');
        var eventIds = query.split(',');
        console.log('EventIds: ' + eventIds);
        this.selectedBoxes = Enumerable.from(eventIds)
          .select((x) => parseInt(x))
          .toArray();

        var conferenceId = +params.get('conferenceId');
        this.streamboxService.getRoomsForConferences().subscribe((result) => {
          this.rooms = result;
          //this.selectedRoom = Enumerable.from(this.rooms).firstOrDefault(x => x.channel == "Channel" + this.streamBoxId)?.id;

        });


        var model = new GetStreamboxStateViewModel();
        model.ids = this.selectedBoxes;
        this.streamboxService.getState(model).subscribe((result) => {
          this.streamboxes = result;
        });

        of(null)
          .pipe(delay(2000))
          .subscribe((result) => {
            this.InitOpenTok();
          });

        this.InitSignalR();
        this.initialized = true;
      });
    });
  }

  InitSignalR(): any {
    this.connection = new HubConnectionBuilder()
      .withUrl('/streamBoxHub', {accessTokenFactory: () => this.auth.getToken()})
      .withAutomaticReconnect(new DefaultReconnectPolicy())
      .build();

    this.connection.start().then(() => {});

    this.connection.on('PanUp', (id) => {
      console.log('Pan up' + id);
    });

    this.connection.on('StateUpdated', (id: number, state: StreamBoxStateViewModel) => {
      console.log('State updated');
      console.log(state);
      var index = this.streamboxes.findIndex((x) => x.id == id);
      this.streamboxes[index] = state;

      if (this.selectedBox.id == id) {
        this.selectedBox = this.streamboxes[index];
      }

    });

    this.initialized = true;
  }

  panUp() {
    console.log(this.streamBoxId);
    this.connection.invoke('PanUp', this.streamBoxId);
  }

  panDown() {
    this.connection.invoke('PanDown', this.streamBoxId);
  }

  panLeft() {
    this.connection.invoke('PanLeft', this.streamBoxId);
  }

  panRight() {
    this.connection.invoke('PanRight', this.streamBoxId);
  }

  zoomIn() {
    this.connection.invoke('ZoomIn', this.streamBoxId);
  }

  zoomOut() {
    this.connection.invoke('ZoomOut', this.streamBoxId);
  }

  zoomStop() {
    this.connection.invoke('ZoomStop', this.streamBoxId);
  }

  panStop() {
    this.connection.invoke('PanStop', this.streamBoxId);
  }

  mute() {
    this.connection.invoke('mute', this.streamBoxId);
  }

  unmute() {
    this.connection.invoke('unmute', this.streamBoxId);
  }

  startRecord() {
    this.connection.invoke('startRecord', this.streamBoxId);
  }

  stopRecord() {
    this.connection.invoke('stopRecord', this.streamBoxId);
  }

  public stopStreaming() {
    this.connection.invoke('stopStreaming', this.streamBoxId);
  }

  public startStreaming() {
    this.connection.invoke('startStreaming', this.streamBoxId);

  }

  superSource16x9() {
    this.connection.invoke("Macro", this.streamBoxId, 1);
  }

  superSource4x3() {
    this.connection.invoke('Macro', this.streamBoxId, 0);
  }

  panelLayout() {
    this.connection.invoke('Macro', this.streamBoxId, 2);
  }

  setProgram(input: number) {
    this.connection.invoke('setProgram', this.streamBoxId, input);
  }

  public startStreamMacro() {
    this.connection.invoke('setProgram', this.streamBoxId, 6000);
    this.connection.invoke('UnmuteInput', this.streamBoxId, 1301);
    this.connection.invoke('UnmuteInput', this.streamBoxId, 1302);
    this.connection.invoke('MuteInput', this.streamBoxId, 8);
  }

  public stopStreamMacro() {
    this.connection.invoke('setProgram', this.streamBoxId, 3020);
    this.connection.invoke('MuteInput', this.streamBoxId, 1301);
    this.connection.invoke('MuteInput', this.streamBoxId, 1302);
    this.connection.invoke('UnmuteInput', this.streamBoxId, 8);
  }

  public toggleMute(number: number, currentMuteState: boolean) {
    if (!currentMuteState) {
      console.log('Unmute');
      this.connection.invoke('UnmuteInput', this.streamBoxId, number);
    } else {
      console.log('Mute');
      this.connection.invoke('MuteInput', this.streamBoxId, number);

    }
  }

  setSelected(streamBoxName: string) {
    console.log(streamBoxName);
    var screensOrVideos = this.webRTCLayoutContainer.nativeElement.querySelectorAll('.OT_subscriber');
    var selected = this.webRTCLayoutContainer.nativeElement.querySelectorAll('.' + streamBoxName);

    console.log(screensOrVideos);
    screensOrVideos.forEach((element) => {
      element.classList.remove('OT_selected');
    });

    selected.forEach((element) => {
      element.classList.add('OT_selected');
    });

    this.streamBoxId = +streamBoxName.replace('Streambox', '');
    console.log(this.streamBoxId);
    this.selectedBox = Enumerable.from(this.streamboxes).firstOrDefault((x) => x.id == this.streamBoxId);
  }

  InitOpenTok() {
    this.ref.detectChanges();
    this.layout = initLayoutContainer(this.webRTCLayoutContainer.nativeElement).layout;
    let layout = this.layout;
    let base = this;

    // var ids = [9, 10, 13, 14];

    this.selectedBoxes.forEach((boxId) => {
      this.opentokService
        .initsessionForStreamBox(boxId)
        .then((session: OT.Session) => {
          session.on('streamCreated', (event) => {
            console.log(event.stream.name);
            console.log(event.stream.connection.data);

            var streamBoxName = event.stream.name;
            var streamBoxId = event.stream.name?.replace('Streambox', '');

            var room = Enumerable.from(this.rooms).firstOrDefault(x => x.channel == "Channel" + streamBoxId);
            event.stream.name = event.stream.name + ' - ' + room?.conferenceName + ' - ' + room?.roomName;

            let subscription = session.subscribe(event.stream, 'webRTCLayoutContainer', {
              insertMode: 'append',
              fitMode: 'contain',
              subscribeToAudio: false,
              preferredResolution: {
                width: 1280,
                height: 720
              },
              style: {nameDisplayMode: 'on'},
            });

            subscription.element.addEventListener('dblclick', function () {
              if (subscription.element.classList.contains('OT_big')) {
                subscription.element.classList.remove('OT_big');
              } else {
                subscription.element.classList.add('OT_big');
              }
              layout();
            });

            subscription.element.classList.add(streamBoxName);

            subscription.element.addEventListener('click', function () {
              base.setSelected(streamBoxName);
            });

            layout();
            this.ref.detectChanges();

            layout();
          });
        })
        .then(() => {
          this.opentokService.connect().then(() => {
            this.openTokInitialized = true;
            console.log('conected');
          });
        })
        .catch((err) => {
          console.error(err);
          alert('Unable to connect.');
        });
    });
  }

  disconnect() {
    if (this.publisher) {
      //this.session.unpublish(this.publisher);
    }

    this.publishing = false;
    this.layout();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.layout();
  }

  // connect() {
  //   const OT = this.opentokService.getOT();
  //   const el = this.renderer.createElement('div');

  //   if (this.selectedDevice) {
  //     this.publisher = OT.initPublisher(el, { publishAudio: true, publishVideo: true, mirror: false, resolution: '1280x720', name: 'Streamcase1', fitMode: 'contain', width: '100%', insertDefaultUI: true, style: { nameDisplayMode: 'on', archiveStatusDisplayMode: 'off', buttonDisplayMode: 'off' }, audioSource: this.selectedDevice.audioDeviceId, videoSource: this.selectedDevice.videoDeviceId });
  //   } else {
  //     this.publisher = OT.initPublisher(el, { publishAudio: true, publishVideo: true, mirror: false, resolution: '1280x720', name: 'Streamcase1', fitMode: 'contain', width: '100%', insertDefaultUI: true, style: { nameDisplayMode: 'on', archiveStatusDisplayMode: 'off', buttonDisplayMode: 'off' } });
  //   }

  //   let layout = this.layout;
  //   el.addEventListener('dblclick', function () {
  //     if (el.classList.contains('OT_big')) {
  //       el.classList.remove('OT_big');
  //     } else {
  //       el.classList.add('OT_big');
  //     }
  //     layout();
  //   });

  //   this.renderer.appendChild(this.webRTCLayoutContainer.nativeElement, el);
  //   layout();

  //   this.session.publish(this.publisher, (err) => {
  //     if (err) {
  //       alert(err.message);
  //       this.layout();
  //     } else {
  //       this.publishing = true;
  //       this.layout();
  //       this.ref.detectChanges();
  //       this.layout();
  //     }
  //   });
  //}

  exitPage() {}

  showDeviceSettings() {
    const modalRef = this.modalService.open(CameraTestModalComponent, {
      size: 'lg',
      backdrop: 'static',
      ariaLabelledBy: 'modal-basic-title'
    });
    if (this.selectedDevice) {
      console.log(this.selectedDevice);
      modalRef.componentInstance.selectedDevice = this.selectedDevice;
    }
    modalRef.result.then(
      (result) => {
        this.selectedDevice = result;

        if (this.publisher) {
          this.publisher.setAudioSource(this.selectedDevice.audioDeviceId);
          this.publisher.setVideoSource(this.selectedDevice.videoDeviceId);
        }
      },
      (reason) => {}
    );
    return;
  }

  protected readonly EventRole = EventRole;


}
